<template>
	<div class="single-page-wrap">
		<cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions">
			<div>
				<div class="weui-form__control-area">
					<div class="weui-cells__group weui-cells__group_form">
						<div class="weui-cells weui-cells_checkbox">
							<label class="weui-cell weui-check__label">
								<div class="weui-cell__bd">
									<p v-if="ticketInfo.type==1">
										<p style="line-height: 2;display: flex; justify-content: space-between">
											<span class="ticketInfo-content">公司税号：{{ticketInfo.buyerTaxcode}}</span>
										</p>
									</p>
									<p style="line-height: 2;display: flex; justify-content: space-between">
										<span class="ticketInfo-content">公司名称：{{ticketInfo.buyerName}}</span>
									</p>
									<p style="line-height: 2;display: flex; justify-content: space-between">
										<span class="ticketInfo-content">电子邮箱：{{ticketInfo.email}}</span>
									</p>
									<p style="line-height: 2;display: flex; justify-content: space-between">
										<span class="ticketInfo-content">手机号码：{{ticketInfo.phone}}</span>
									</p>
								</div>
							</label>
							<label class="weui-cell weui-check__label"
								   :for="item.id" v-for="item of ticketDetails">
								<div class="weui-cell__bd">
									<p style="line-height: 2;display: flex; justify-content: space-between">
										<span class="ticketInfo-content">区域名称：{{item.areaName}}</span>
									</p>
									<p style="line-height: 2;display: flex; justify-content: space-between">
										<span class="ticketInfo-content">商户订单：{{item.orderSn}}</span>
									</p>
									<p style="line-height: 2;display: flex; justify-content: space-between">
										<span class="ticketInfo-content">开票订单：{{ticketInfo.rorder}}</span>
									</p>
									<p style="line-height: 2;display: flex; justify-content: space-between;align-items: center">
										<span class="ticketInfo-content">{{item.parkName || '停车缴费：'+item.totalPrice}}</span>
									</p>
									<div >
										<p>
											<span  class="ticketInfo-content">{{ticketInfo.updateTime?'开票状态：已红冲':'开票状态：已开票'}}</span>
											<br>
											<span  class="ticketInfo-content">开票时间：{{ticketInfo.createTime}}</span>
										</p>
										<p v-if="ticketInfo.updateTime">
											<span  class="ticketInfo-content">红冲时间：{{ticketInfo.updateTime}}</span>
										</p>
									</div>
								</div>
							</label>
						</div>
						<div v-if="!ticketInfo.updateTime" class="weui-cell__ft" style="text-align: left;margin-top: 5px;">
							<button class="weui-btn weui-btn_default weui-vcode-btn" @click="ticketReverse">
								红冲</button>
						</div>
					</div>
				</div>
			</div>
		</cube-scroll>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import { chinaUnionticketReverse } from "../../../api/coupon/ticketDetails";

    export default {
        name: "index",
		data () {
            return {
                ticketDetails: [],
                ticketInfo: undefined,
                orderArr: [],
                parkinglotId: undefined,
                scrollOptions: {
                    click: true,
                    bounce: false
                },
                goodsTypeOptions: {
                    1: "充值余额",
                    2: "出口缴费",
                    3: "场内支付",
                    4: "商家购买停车券",
                    5: "普通用户购买停车券"
                }
			}
		},
		computed: {
			...mapGetters(['userOpenid'])
		},
		created () {
            if (this.$route.params.ticketDetails){
                this.ticketDetails = this.$route.params.ticketDetails;
			}
            if (this.$route.params.ticketInfo){
                this.ticketInfo = this.$route.params.ticketInfo;
				this.orderArr.push(this.ticketInfo.rorder);
				this.parkinglotId = this.ticketInfo.parkinglotId;
			}
		},
		methods: {
			ticketReverse () {
                chinaUnionticketReverse({orderArr:this.orderArr,parkinglotId:this.parkinglotId})
				.then(res =>{
					if (res.code == 200) {
						this.showAlert("发票红冲成功!!");
					}else{
						this.showAlert("发票红冲异常，请重试");
					}
				})
			},
			showAlert(value) {
                this.$createDialog({
                    type: "confirm",
                    icon: "cubeic-alert",
                    title: "提示",
                    content: value,
                    confirmBtn: {
                        text: "返回上一层",
                        active: true,
                        disabled: false,
                        href: "javascript:;"
                    },
					onConfirm: () => {
						this.$router.go(-1);
					},
                }).show();
                this.hint = value;
                this.isShowHint = false;
            },
		}
    }
</script>

<style scoped lang="stylus">
	.cube-scroll {
		position: relative;
		text-align: left;
		white-space: normal;
		max-height: 95%
		overflow hidden
		/*background: #ffffff;*/
		margin-bottom 20px
		.no-data-wrap {
			padding-top 25%
			display flex
			justify-content center
			align-items center
			.weui-article{
				color $no-data-font-color
				h1{
					font-size $no-data-font-size
				}
			}
		}
		.weui-form__control-area{
			margin-top 0
		}
		.weui-cells:before{
			border-top none
		}
		.weui-cells__group_form .weui-cell{
			padding  16px
		}
	}
	.ticketInfo-content{
		line-height: 2;
		font-size: 14px
	}
	.line_fg{  
    padding: 0 20px 0;  
    margin: 20px 0;  
    line-height: 1px;  
    border-left: 190px solid #ddd;  
    border-right: 190px solid #ddd;  
    text-align: center;  
	border-top: 1px solid #ddd;
	}
</style>